import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { api } from './api';
import { PARENTS, PATIENTS, CHILDREN, DROPDOWNS, UPLOAD, buildUrl } from './api/endpoints';
import apiService from '../../shared/services/apiService';

// Create base CRUD service for patients (list from patients, CRUD from admin/parents)
const baseCRUD = createCRUDService(PARENTS.BASE, {
  listEndpoint: PATIENTS.BASE
});

// Children CRUD service
const childrenCRUD = createCRUDService(CHILDREN.BASE);


/* --------------------
   PARENT OPTIONS
----------------------- */
// export const getParentOptions = async () => {
//   try {
//     const res = await apiService.getAll('admin/parents');


//     const parents = res?.data || [];
//     return parents.map(p => ({ value: p._id, label: p.fullName, key: p._id }));
//   } catch (error) {
//     console.warn('Failed to load parents from dropdowns API', error);
//     return [];
//   }
// };
export const getParentOptions = async () => {
  try {
    const res = await apiService.getAll('admin/parents');
    const parents = res?.data || [];
    
    return parents.map(p => ({
      value: p.id,
      label: p.fullName,
      key: p.id
    }));
  } catch (error) {
    console.warn('Failed to load parents from dropdowns API', error);
    return [];
  }
};
// Export service with additional custom methods
export const PatientService = {
  ...baseCRUD,

  // Dropdown data
  getDropdowns: () => fetchDropdowns(DROPDOWNS.BASE),

  // Children management
  getChildren: async ({ page = 1, limit = 5, parentId = '', search = '' } = {}) => {
    const params = { page, limit };
    if (parentId) params.parentId = parentId;
    if (search) params.search = search;

    const response = await api.get(buildUrl(CHILDREN.ALL, params));
    return response.data;
  },

  getChildById: (id) => childrenCRUD.getById(id),
  createChild: (data) => childrenCRUD.create(data),
  updateChild: (id, data) => childrenCRUD.update(id, data),
  deleteChild: (id) => childrenCRUD.delete(id),

  // Get children by parent ID using /api/v1/admin/parents/:id/children
  getChildrenByParentId: async (parentId) => {
    const response = await api.get(PARENTS.CHILDREN(parentId));
    return response.data;
  },

  // Profile photo upload
  uploadProfilePhoto: async (formData) => {
    const response = await api.upload(UPLOAD.PROFILE_PHOTO, formData);
    return response.data;
  },
};

export default PatientService;
